import React from 'react';
import { DayPicker, DateRange } from 'react-day-picker';
import 'react-day-picker/style.css';
import { NewTripRequest } from '../../types';

interface StepProps {
  formData: NewTripRequest;
  setFormData: React.Dispatch<React.SetStateAction<NewTripRequest>>;
}

const StepDatesInterests: React.FC<StepProps> = ({ formData, setFormData }) => {
  // Helpers for dates
  const pad2 = (n: number) => String(n).padStart(2, '0');
  const formatDateLocal = (date: Date): string => {
    const y = date.getFullYear();
    const m = pad2(date.getMonth() + 1);
    const d = pad2(date.getDate());
    return `${y}-${m}-${d}`;
  };
  const parseLocalDateString = (s?: string): Date | undefined => {
    if (!s) return undefined;
    const parts = s.split('-').map(Number);
    if (parts.length !== 3 || parts.some(isNaN)) return undefined;
    return new Date(parts[0], parts[1] - 1, parts[2]);
  };

  const from = parseLocalDateString(formData.startDate);
  const to = parseLocalDateString(formData.endDate);
  const selectedRange: DateRange | undefined = (from || to) ? { from, to } : undefined;

  return (
    <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500">
      
      {/* Date Selection */}
      <div className="space-y-4">
        <h3 className="text-lg font-medium text-gray-900">When are you traveling? *</h3>
        <div className="flex flex-col md:flex-row gap-6">
            <div className="bg-white border border-gray-200 rounded-xl p-4 shadow-sm w-full md:w-auto flex justify-center">
                <DayPicker
                    mode="range"
                    selected={selectedRange}
                    defaultMonth={from || new Date()}
                    numberOfMonths={1}
                    pagedNavigation
                    onSelect={(range) => {
                        setFormData(prev => ({
                            ...prev,
                            startDate: range?.from ? formatDateLocal(range.from) : '',
                            endDate: range?.to ? formatDateLocal(range.to) : ''
                        }));
                    }}
                    weekStartsOn={1}
                    className="m-0"
                    modifiersClassNames={{
                        selected: 'bg-primary-600 text-white rounded-full',
                        range_start: 'bg-primary-600 text-white rounded-l-full',
                        range_end: 'bg-primary-600 text-white rounded-r-full',
                        range_middle: 'bg-primary-100 text-primary-900',
                    }}
                />
            </div>
            
            {/* Selected Dates Display */}
            <div className="flex-1 flex flex-col justify-center gap-4">
               <div className="bg-gray-50 p-4 rounded-xl border border-gray-200">
                  <span className="block text-xs uppercase tracking-wide text-gray-500 font-semibold mb-1">Start Date</span>
                  <div className="text-xl font-medium text-gray-900">
                    {from ? from.toLocaleDateString(undefined, { weekday: 'short', month: 'long', day: 'numeric', year: 'numeric' }) : 'Select date'}
                  </div>
               </div>
               <div className="bg-gray-50 p-4 rounded-xl border border-gray-200">
                  <span className="block text-xs uppercase tracking-wide text-gray-500 font-semibold mb-1">End Date</span>
                  <div className="text-xl font-medium text-gray-900">
                    {to ? to.toLocaleDateString(undefined, { weekday: 'short', month: 'long', day: 'numeric', year: 'numeric' }) : 'Select date'}
                  </div>
               </div>
                {from && to && (
                     <div className="bg-primary-50 p-4 rounded-xl border border-primary-100 text-center">
                        <span className="text-primary-800 font-medium">
                            {Math.ceil((to.getTime() - from.getTime()) / (1000 * 60 * 60 * 24)) + 1} Days Trip
                        </span>
                     </div>
                )}
            </div>
        </div>
      </div>
    </div>
  );
};

export default StepDatesInterests;
